<template>
  <!-- AI F §1.1.10 — runs a real knowledge base search -->
  <div class="p-8">
    <woot-modal-header
      :header-title="$t('KNOWLEDGE_BASE.TEST_QUERY.TITLE')"
      :header-content="$t('KNOWLEDGE_BASE.TEST_QUERY.DESC')"
    />
    <form class="mt-4" @submit.prevent="runSearch">
      <woot-input
        v-model="query"
        :placeholder="$t('KNOWLEDGE_BASE.TEST_QUERY.PLACEHOLDER')"
        :label="$t('KNOWLEDGE_BASE.TEST_QUERY.LABEL')"
      />
      <div class="flex justify-end gap-2">
        <woot-button variant="clear" @click.prevent="$emit('close')">
          {{ $t('KNOWLEDGE_BASE.TEST_QUERY.CLOSE') }}
        </woot-button>
        <woot-button
          :is-loading="uiFlags.isSearching"
          :disabled="!query.trim()"
          type="submit"
        >
          {{ $t('KNOWLEDGE_BASE.TEST_QUERY.RUN') }}
        </woot-button>
      </div>
    </form>

    <div v-if="result" class="mt-5">
      <div v-if="result.custom_answer" class="rounded bg-green-50 p-3 text-sm">
        <div class="font-medium mb-1">
          {{ $t('KNOWLEDGE_BASE.TEST_QUERY.CUSTOM_ANSWER') }} ·
          {{ result.custom_answer.source_name }}
        </div>
        <!-- AI F §1.5.1 — the answer keeps its formatting -->
        <div
          v-dompurify-html="formatMessage(result.custom_answer.answer, false)"
          class="answer-body"
        />
      </div>
      <p v-else-if="!result.chunks.length" class="text-sm text-slate-500">
        {{ $t('KNOWLEDGE_BASE.TEST_QUERY.NO_RESULTS') }}
      </p>
      <div
        v-for="(chunk, index) in result.chunks"
        :key="index"
        class="border-b border-slate-50 py-3 text-sm"
      >
        <div class="flex gap-2 text-slate-500 mb-1">
          <span class="flex-1">{{ chunk.source_name }}</span>
          <span>{{ chunk.score }}</span>
        </div>
        <p class="whitespace-pre-wrap">{{ chunk.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';

export default {
  mixins: [alertMixin, messageFormatterMixin],
  data() {
    return { query: '', result: null };
  },
  computed: {
    ...mapGetters({ uiFlags: 'kbSources/getUIFlags' }),
  },
  methods: {
    async runSearch() {
      try {
        this.result = await this.$store.dispatch(
          'kbSources/search',
          this.query.trim()
        );
      } catch (error) {
        this.showAlert(
          error?.response?.data?.error ||
            this.$t('KNOWLEDGE_BASE.TEST_QUERY.ERROR')
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .answer-body {
    ol {
      @apply list-decimal ltr:pl-5 rtl:pr-5;
    }

    ul {
      @apply list-disc ltr:pl-5 rtl:pr-5;
    }
  }
}
</style>
